import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import InfoWhiteIcon from "../../../../assets/icons/info-purple.svg";
import "./FreeSubscriptionHelpModal.less";

export type FreeSubscriptionHelpModalProps = {
  onClose: () => void;
};

const FreeSubscriptionHelpModal: React.FC<FreeSubscriptionHelpModalProps> = ({ onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    // Bloquer le scroll de la page en arrière-plan
    document.body.style.overflow = "hidden";

    return () => {
      // Restaurer le scroll quand la modal se ferme
      document.body.style.overflow = "";
    };
  }, []);

  const handleOverlayClick = () => {
    onClose?.();
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="free-subscription-help-bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="free-subscription-help-bottom-modal-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>

        <div className="free-subscription-help-bottom-modal-scrollable">
          <img src={InfoWhiteIcon} className="free-subscription-help-bottom-modal-icon" alt="Info" />

          <div className="free-subscription-help-section-title">{t("free-subscription-explanation-title")}</div>

          <div className="free-subscription-help-description">{t("free-subscription-explanation-desc-1")}</div>

          <div className="free-subscription-help-description">{t("free-subscription-explanation-desc-2")}</div>

          <div className="free-subscription-help-section-title">{t("free-subscription-fan-subscribed-title")}</div>

          <div className="free-subscription-help-numbered-item">
            <span className="free-subscription-help-number">1.</span>
            <span className="free-subscription-help-description">{t("free-subscription-point-1")}</span>
          </div>

          <div className="free-subscription-help-numbered-item">
            <span className="free-subscription-help-number">2.</span>
            <span className="free-subscription-help-description">{t("free-subscription-point-2")}</span>
          </div>

          <div className="free-subscription-help-numbered-item">
            <span className="free-subscription-help-number">3.</span>
            <span className="free-subscription-help-description">{t("free-subscription-point-3")}</span>
          </div>
        </div>

        <div className="free-subscription-help-bottom-modal-footer">
          <button className="free-subscription-help-bottom-modal-accept-button" onClick={onClose}>
            {t("i-understand")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FreeSubscriptionHelpModal;
